import type { ReactNode } from "react";

/** One line of the Thread header's hosting: where it runs, and what you can do about it (F55). */
export default function HostingRow({ children }: { children: ReactNode }) {
  return <p className="app-text-muted flex flex-wrap items-center gap-x-2 gap-y-1 text-xs">{children}</p>;
}
